import {runValidationsAndSync, runValidationsAndSyncAfterChange} from '../validationsService/validationsService';

const validationsEventHandler = (RMI) => (e) => {
    const value = e.target.value;
    const compId = e.syntheticEvent.id;

    runValidationsAndSyncAfterChange(RMI, compId, value);
};

const updateValidationState = (RMI, contextId, compId) => runValidationsAndSync(RMI, compId);

const validatableWithSyncInitialize = (RMI, contextId, compId) => {
    RMI.registerEvent(contextId, compId, RMI.getEventTypes().CHANGE, null, validationsEventHandler(RMI));
    updateValidationState(RMI, contextId, compId);
};

export default validatableWithSyncInitialize;
